<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" :is_data="is_data" v-on:emitForm="close" v-if="showForm"></insertForm>

    <v-container>
      <v-card>
        <v-card-title>
          <h2>Assets Issue/ Reissue/ Movement List</h2>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="search"
            label="Search"
            single-line
            hide-details
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <span style="display:none;">{{serial=serialNumber}}</span>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :total-items="totalDesserts"
          :loading="loading"
          class="elevation-4"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ serial++ }}</td>
            <td class="text-xs-left">{{ props.item.asset_name }}</td>
            <td class="text-xs-left">{{ (props.item.new_location_name == null) ? props.item.location_name : props.item.new_location_name }}</td>
            <td class="text-xs-left">{{ (props.item.new_employee_name == null) ? props.item.employee_name : props.item.new_employee_name }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.issue_date) }}</td>
            <td class="text-xs-left">{{ props.item.status_title }}</td>
            <td class="text-xs-left">{{ props.item.issue_title }}</td>   
            
            <td class="">
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.updateButton"
                @click="editItem(props.index,props.item)"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                v-if="userRole.deleteButton"
                @click="deleteItem(props.index, props.item.asset_id)"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="addDetails(props.item)" title="Detail">
                <v-icon color="teal">view_module</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");
import insertForm from "./asset_movement_form";
import Axios from "axios";
import ServerPath from '../../../server-path/server-path';

export default {
  components: {
    insertForm
  },

  data: () => ({
    showForm: false, // Add edit form controll during user permission
    dialog: false,
    totalItems: 0,

    items: [],

    //Delete data related instance--------
    delete_id: "",
    row_index: "",
    confirmModel: false,

    // snacber script instance ----------
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },
    is_data: false,
    formSchema: {
      id: "",
      asset_id: "",
      asset_code: "",
      asset_location_id: "",
      employee_id: "",
      new_asset_location_id:"",
      new_employee_id:"",
      issue_date: "",
      close_date: "",
      asset_status: "",
      issue_status: "",
    },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      { text: "SL", value: "" },
      {
        text: "Asset Name",
        align: "left",
        sortable: true,
        value: "asset_name"
      },
      {
        text: "Location",
        align: "left",
        sortable: true,
        value: "location_name"
      },
      {
        text: "User Name",
        align: "left",
        sortable: true,
        value: "employee_name"
      },

      { text: "Assign Date", sortable: true, value: "issue_date" },
      { text: "Asset Status", value: "asset_status" },
      { text: "Movement Status", value: "issue_status" },
      { text: "Action", value:'' }
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          if ( typeof(data.items) !== 'undefined') {
            this.desserts = data.items;
          }
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

    // User Previlization methods
    userRole() {
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },

  methods: {
    addDetails(items)
    {
      let query_Data2 = []; 
      (query_Data2.asset_id = items.asset_id)

      let parameters = new URLSearchParams({ ...query_Data2}).toString();
      let route = ServerPath.serverPath+'/asset-movement-details-pdf?'+parameters;
      window.open(route, '_blank');
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .insertFormData(query_Data, "asset_movement_info")
          .then(res => {
            this.showForm = this.userRole.saveButton;
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
              
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    editItem(index, data) {
      //console.log(this.formSchema.new_asset_location_id)
      this.showForm = true;
      this.row_index = index;
      data.issue_date = this.changeFormateDMY(data.issue_date);
      data.close_date = this.changeFormateDMY(data.close_date);
      this.formSchema = { ...data };
      if(this.formSchema.new_asset_location_id == null){
        this.is_data = 0;
      }
      else{ 
        this.is_data = 1;
      }
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      // data delete confirm modal
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "asset_movement").then(res => {
        this.desserts.splice(row_index, 1);
        this.close(res);
        this.confirmModel = false;
      });
    },

    //  Request response Massage !!!
    close(res) {
      this.showForm = this.userRole.saveButton;
      if (res.status == 1) {

        this.getDataFromApi().then(data => {
          if ( typeof(data.items) !== 'undefined') {
            this.desserts = data.items;
          }
          this.totalDesserts = data.total;
        });

        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
          if (res.action == "add") {
            this.desserts.unshift({ ...res.data })
          }

          if (res.action == "edit") {
            this.$set(this.desserts, this.row_index, { ...res.data });
            this.row_index = "";
          }

        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
        
      } else {
        this.SnackbarVal.color = "error";
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
      }
    }
    // End  Request response Massage !!!
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/asset_movement/asset_movement_list.vue